//BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - Start
import { memo, useMemo } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { EXPAND_RECENT_SEARCH_LENGTH, RECENT_SEARCH_LENGTH, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useSelector } from 'react-redux';
import { BzButton, BzChip } from '../../components';
const RecentSearch = ({ isExpand, handleRecentSearch, onChangeGlobalSearch, isGlobal, onBuySellClick, addScrips, scripDetails, removeScrips, handleSelectedPage }) => {
    const scrips = useSelector(state => state.globalSearch.arrRecentlySearchScrips);
    const arrScripsToBeAdded = useSelector(state => state.globalSearch.arrScripsToBeAdded);

    const nScripLimit = useMemo(() => {
        if (isExpand) {
            var nScripLimit = EXPAND_RECENT_SEARCH_LENGTH;
        }
        else {
            nScripLimit = RECENT_SEARCH_LENGTH;
        }
        return nScripLimit;
    }, [isExpand]);
    // useEffect(() => {
    //     const searchArray = getDecryptLocalStorage('RECENTLY_SEARCHED');
    //     if (searchArray) {
    //         const parsedArray = JSON.parse(searchArray);
    //         let objActiveUserRecentSearch = parsedArray?.find((each) => each?.user_id === objLoginSession?.data?.user_id) 
    //         dispatch(setArrRecentlySearchScrips(objActiveUserRecentSearch));
    //     } else { }
    // }, []);
    const strExtraClassName = isGlobal ? 'px-3' : '';
    const strClassname = `p-0 ${strExtraClassName}`;

    return (
        <>

            {
                scrips?.arrRecentScrips?.length > 0 &&
                <Container fluid className={strClassname}>
                    <Row className='g-0 mt-4 mb-3'>
                        <Col className='d-flex align-items-center'>
                            <div class='icon-20 icon-recent-search icon-dark me-3'></div>
                            <div data-testid='global-search-recent-search-label' className='font-medium font-size3 color-text'>Recently Searched</div>
                        </Col>
                    </Row>
                    {scrips?.arrRecentScrips?.length > 0 && scrips?.arrRecentScrips?.map((each, i) =>
                        <>   
                            {i < nScripLimit && 
                                <Row className='g-0 py-2' key={i}>
                                    {i < nScripLimit &&
                                        <>
                                            <Col md={9} className='d-flex justify-content-start align-items-center'>
                                                <Container fluid className='p-0'>
                                                    <Row className='g-0' onClick={() => { onChangeGlobalSearch({ target: { value: each?.displayName ? each?.displayName : each[WATCHLIST_GRID_INDEX.DISPLAY_DESC] } }); }}>
                                                        <Col className='d-flex justify-content-start align-items-center'>
                                                            <div data-testid='global-search-recent-search-element' className='font-medium font-size3 color-text cursor-pointer text-nowrap me-2'>{each?.displayName ? each?.menuDescription : each[WATCHLIST_GRID_INDEX.DISPLAY_DESC]}</div>
                                                            {each?.displayName ? '' : <div className='chips-wrap'>
                                                                <BzChip className='exchange-chip'>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                                            </div>}
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 pt-1'>
                                                        <Col className='d-flex justify-content-start'>
                                                            <div className='font-regular font-size3 color-subtext cursor-pointer text-uppercase'>{each?.displayName ? '' : each[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION]}</div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>
                                            {each?.displayName ?
                                            <Col md={3} className='d-flex justify-content-end align-items-center'>
                                                <div className='icon-16 icon-forward-arrow icon-dark' onClick={() => { onChangeGlobalSearch({ target: { value: each?.displayName ? each?.displayName : each[WATCHLIST_GRID_INDEX.DISPLAY_DESC] } }); }}></div>    {/* Bhagyashri P [19-12-2023] : class changes for Global Search Feature */}
                                            </Col>
                                            :
                                            <Col md={3} className='d-flex justify-content-end align-items-center btn-tabfocus'>
                                                <> <BzButton className='btn btn-sm btn-positive text-capitalize ms-2' onClick={(e) => { e.stopPropagation(); onBuySellClick("Buy", each); }} >B</BzButton>
                                                    <BzButton className='btn btn-sm btn-negative text-capitalize ms-2' onClick={(e) => { e.stopPropagation(); onBuySellClick("Sell", each); }} >S</BzButton>
                                                    {arrScripsToBeAdded?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])
                                                        ?
                                                        <BzButton className='btn btn-sm' onClick={(e) => { e.stopPropagation(); removeScrips(e, each); }}><span className='icon-24 icon-minus-circle icon-dark'></span></BzButton>
                                                        : <BzButton className='btn btn-sm' onClick={(e) => { e.stopPropagation(); addScrips(e, each); }}><span className='icon-24 icon-add-circle icon-dark'></span></BzButton>
                                                    }
                                                </>
                                            </Col>}
                                        </>
                                    }
                                </Row>
                            }    
                        </>  
                    )}
                </Container>
            }
        </>
    );
};

export default memo(RecentSearch);
//BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - End